import { v4 as uuid } from "uuid";

/**
 * Product Database can be added here.
 * You can add products of your wish with different attributes
 * */

export const products = [
  {
    _id: uuid(),
    name: "Stylish casual partywear women heeled boots Boots For Women  (Brown)",
    brand: "ADIDAS",
    image:
      "https://rukminim1.flixcart.com/image/832/832/xif0q/shoe/i/d/p/-original-imagg3m8qtqrkga8.jpeg?q=70",
    category: "Boots",
    price: "2500",
    originalPrice: "3459",
    rating: "2.8",
    gender: "Women",
    inStock: true,
    reviews: "96",
    delivery: "in 2 days",
  },

  {
    _id: uuid(),
    name: "Vidal E Sneakers For Men  (Black)",
    brand: "BATA",
    image:
      "https://rukminim1.flixcart.com/image/612/612/xif0q/shoe/k/z/o/-original-imaggdacrvcpt736.jpeg?q=70",
    category: "Sneakers",
    price: "1999",
    originalPrice: "3500",
    rating: "2.2",
    gender: "Men",
    inStock: false,
    reviews: "3.3k",
    delivery: "in 2 days",
  },

  {
    _id: uuid(),
    name: "RS-Z Reinvention Sneakers For Men  (Grey)",
    brand: "PUMA",
    image:
      "https://rukminim1.flixcart.com/image/832/832/xif0q/shoe/t/h/o/6-786-labbin-brown-original-imagngj44gw4mzvd.jpeg?q=70",
    category: "Sneakers",
    price: "7999",
    originalPrice: "11000",
    rating: "4.5",
    gender: "Men",
    inStock: true,
    reviews: "5.5k",
    delivery: "in 3 days",
  },

  {
    _id: uuid(),
    name: "W NKDOWNSHIFTER 12 Sneakers For Women  (White)",
    brand: "NIKE",
    image:
      "https://rukminim1.flixcart.com/image/832/832/xif0q/shoe/l/h/m/-original-imagk8t89zcvhnb3.jpeg?q=70",
    category: "Sneakers",
    price: "3554",
    originalPrice: "5000",
    rating: "4",
    gender: "Women",
    inStock: true,
    reviews: "1.1k",
    delivery: "in 1 days",
  },
  {
    _id: uuid(),
    name: "VULC RAID3R Sneakers For Women  (White)",
    brand: "ADIDAS",
    image:
      "https://rukminim1.flixcart.com/image/612/612/xif0q/shoe/z/m/n/7-gz5986-7-adidas-ftwwht-ftwwht-ftwwht-original-imageqxdfq7ffjhv-bb.jpeg?q=70",
    category: "Sneakers",
    price: "2550",
    originalPrice: "3350",
    rating: "1.5",
    gender: "Women",
    inStock: false,
    reviews: "6.3k",
    delivery: "in 4 days",
  },
  {
    _id: uuid(),
    name: "Sneakers For Women  (Blue)",
    brand: "BATA",
    image:
      "https://rukminim1.flixcart.com/image/832/832/xif0q/shoe/0/7/w/8-5899197-8-bata-blue-original-imaggs5zhgvhexff.jpeg?q=70",
    category: "Sneakers",
    price: "1500",
    originalPrice: "2000",
    rating: "2.5",
    gender: "Women",
    inStock: true,
    reviews: "205",
    delivery: "in 3 days",
  },
  {
    _id: uuid(),
    name: "Grandstand II Shoe Sneakers For Men  (White)",
    brand: "NIKE",
    image:
      "https://res.cloudinary.com/dmmqvo37i/image/upload/v1684137317/aa2190-100nike-10-nike-white-navy-sail-arctic-punch-original-imafvgpebjgvsyrj_uyfrb7.jpg",
    category: "Sneakers",
    price: "5000",
    originalPrice: "6669",
    rating: "3.5",
    gender: "Men",
    inStock: true,
    reviews: "2.4k",
    delivery: "in 6 days",
  },
  {
    _id: uuid(),
    name: "Ivana Wn's Sneakers For Women  (Blue)",
    brand: "PUMA",
    image:
      "https://rukminim1.flixcart.com/image/832/832/xif0q/shoe/4/h/2/-original-imagk5kkgvgzzrhk.jpeg?q=70",
    category: "Sneakers",
    price: "7999",
    originalPrice: "1000",
    rating: "4.5",
    gender: "Women",
    inStock: true,
    reviews: "3.0k",
    delivery: "in 6 days",
  },

  {
    _id: uuid(),
    name: "Slip on Sneakers For Boys & Girls  (Yellow)",
    brand: "NIKE",
    image:
      "https://rukminim1.flixcart.com/image/612/612/j7qi9ow0/kids-shoe/g/7/t/10-5c-343738-802-nike-original-imaexwrhkmh3ypvd.jpeg?q=70",
    category: "Sneakers",
    price: "2500",
    originalPrice: "4900",
    rating: "3.8",
    gender: "Kids",
    inStock: true,
    reviews: "2.1k",
    delivery: "in 1 days",
  },
  {
    _id: uuid(),
    name: "Lace Sneakers For Boys & Girls  (Black)",
    brand: "ADIDAS",
    image:
      "https://rukminim1.flixcart.com/image/832/832/krjjde80/kids-shoe/l/w/x/6-12037040-adidas-original-imag5awrukqfgkgx.jpeg?q=70",
    category: "Sneakers",
    price: "1200",
    originalPrice: "4000",
    rating: "1.2",
    gender: "Kids",
    inStock: false,
    reviews: "6.3k",
    delivery: "in 1 days",
  },
  {
    _id: uuid(),
    name: "Lace Sneakers For Boys & Girls  (Red)",
    brand: "PUMA",
    image:
      "https://rukminim1.flixcart.com/image/832/832/xif0q/kids-shoe/2/x/f/10-387053-puma-original-imagg8g8yzhz6pnh.jpeg?q=70",
    category: "Sneakers",
    price: "1500",
    originalPrice: "2110",
    rating: "3.3",
    gender: "Kids",
    inStock: false,
    reviews: "505",
    delivery: "in 2 days",
  },
  {
    _id: uuid(),
    name: "Velcro Casual Shoes For Boys  (White)",
    brand: "BATA",
    image:
      "https://rukminim1.flixcart.com/image/832/832/xif0q/kids-shoe/l/c/n/5-4391549-bata-original-imagh7x2gzzghwfz.jpeg?q=70",
    category: "Sneakers",
    price: "560",
    originalPrice: "1200",
    rating: "2",
    gender: "Kids",
    inStock: true,
    reviews: "8.9k",
    delivery: "in 1 days",
  },

  {
    _id: uuid(),
    name: "NK Flex Control 4 Men's Training Shoes Training & Gym Shoes For Men  (Blue)",
    brand: "NIKE",
    image:
      "https://rukminim1.flixcart.com/image/832/832/xif0q/shoe/e/w/w/6-cd0197-400nike-7-nike-midnight-navy-metallic-silver-black-original-imagfxg2qtgahm5n-bb.jpeg?q=70",
    category: "Sports shoes",
    price: "4999",
    originalPrice: "7000",
    rating: "5",
    gender: "Men",
    inStock: true,
    reviews: "1.02k",
    delivery: "in 3 days",
  },
  {
    _id: uuid(),
    name: "Harquin M Running Shoes For Men  (Black)",
    brand: "ADIDAS",
    image:
      "https://rukminim1.flixcart.com/image/832/832/l3dcl8w0/shoe/y/1/0/8-ga1118-8-adidas-cblack-stone-actgol-original-imagegegxvk3278p.jpeg?q=70",
    category: "Sports shoes",
    price: "6596",
    originalPrice: "11000",
    rating: "3.6",
    gender: "Men",
    inStock: true,
    reviews: "6.9k",
    delivery: "in 2 days",
  },
  {
    _id: uuid(),
    name: "Sports and Oudoor Lace Up Shoes Running Shoes For Men  (Beige)",
    brand: "BATA",
    image:
      "https://rukminim1.flixcart.com/image/832/832/l59xq4w0/shoe/s/k/d/6-833-4995-bata-beige-original-imagfzpjysegskkt.jpeg?q=70",
    category: "Sports shoes",
    price: "4000",
    originalPrice: "6999",
    rating: "2.6",
    gender: "Men",
    inStock: false,
    reviews: "202",
    delivery: "in 5 days",
  },
  {
    _id: uuid(),
    name: "Hustle V2 Running Shoes For Men  (Black)",
    brand: "PUMA",
    image:
      "https://rukminim1.flixcart.com/image/832/832/xif0q/shoe/h/n/u/-original-imaghy4hpgfkemn9.jpeg?q=70",
    category: "Sports shoes",
    price: "7025",
    originalPrice: "12000",
    rating: "4.8",
    gender: "Men",
    inStock: true,
    reviews: "198",
    delivery: "in 4 days",
  },

  {
    _id: uuid(),
    name: "Amalgo W Running Shoes For Women  (Pink)",
    brand: "ADIDAS",
    image:
      "https://rukminim1.flixcart.com/image/832/832/xif0q/shoe/r/v/x/-original-imagn9nagj9a7znz.jpeg?q=70",
    category: "Sports shoes",
    price: "4200",
    originalPrice: "6000",
    rating: "3.5",
    gender: "Women",
    inStock: true,
    reviews: "6.3k",
    delivery: "in 3 days",
  },
  {
    _id: uuid(),
    name: "Amalgo W Running Shoes For Women  (Pink)",
    brand: "NIKE",
    image:
      "https://rukminim1.flixcart.com/image/612/612/xif0q/shoe/0/i/3/8-dc3729-101-9-nike-white-metallic-silver-pure-platinum-original-imagnza5y82g2vde.jpeg?q=70",
    category: "Sports shoes",
    price: "2709",
    originalPrice: "4035",
    rating: "4.1",
    gender: "Women",
    inStock: true,
    reviews: "4.5k",
    delivery: "in 2 days",
  },
  {
    _id: uuid(),
    name: "Indoor and outdoor womens sports runninng Shoes For Women  (Maroon)",
    brand: "BATA",
    image:
      "https://rukminim1.flixcart.com/image/832/832/kjem3rk0-0/shoe/y/x/l/5395377-9-power-maroon-original-imafyz5gdvzr5z3p.jpeg?q=70",
    category: "Sports shoes",
    price: "3638",
    originalPrice: "5048",
    rating: "4.6",
    gender: "Women",
    inStock: true,
    reviews: "100",
    delivery: "in 1 days",
  },
  {
    _id: uuid(),
    name: "Softride Enzo NXT Wn's Running Shoes For Women  (Grey)",
    brand: "PUMA",
    image:
      "https://rukminim1.flixcart.com/image/832/832/xif0q/shoe/0/5/v/-original-imagz4ymp3cdshjt.jpeg?q=70",
    category: "Sports shoes",
    price: "6600",
    originalPrice: "8880",
    rating: "3",
    gender: "Women",
    inStock: true,
    reviews: "9.3k",
    delivery: "in 4 days",
  },
  {
    _id: uuid(),
    name: "EASY VULC 2.0 SS 19 Sneakers For Men  (Blue)",
    brand: "ADIDAS",
    image:
      "https://rukminim1.flixcart.com/image/612/612/jvfk58w0/shoe/r/d/w/f34659-11-adidas-dkblue-ftwwht-actred-original-imafgcytfzghkeb6.jpeg?q=70",
    category: "Sneakers",
    price: "3699",
    originalPrice: "4500",
    rating: "3.2",
    gender: "Men",
    inStock: true,
    reviews: "1.3k",
    delivery: "in 6 days",
  },

  {
    _id: uuid(),
    name: "Lace Running Shoes For Boys & Girls  (Red)",
    brand: "ADIDAS",
    image:
      "https://rukminim1.flixcart.com/image/832/832/krjjde80/kids-shoe/b/s/y/3-13432162-adidas-original-imag5awqyr6dgcda.jpeg?q=70",
    category: "Sports shoes",
    price: "1200",
    originalPrice: "2000",
    rating: "2.2",
    gender: "Kids",
    inStock: true,
    reviews: "2.1k",
    delivery: "in 5 days",
  },
  {
    _id: uuid(),
    name: "Lace Running Shoes For Boys  (Black)",
    brand: "BATA",
    image:
      "https://rukminim1.flixcart.com/image/612/612/l1jmc280/kids-shoe/y/1/j/5-4316363-bata-original-imagd2ynaevfgzhq.jpeg?q=70",
    category: "Sports shoes",
    price: "1700",
    originalPrice: "2500",
    rating: "4.1",
    gender: "Kids",
    inStock: false,
    reviews: "1.8k",
    delivery: "in 1 days",
  },
  {
    _id: uuid(),
    name: "Slip on Running Shoes For Boys and Girls (Black)",
    brand: "NIKE",
    image:
      "https://rukminim1.flixcart.com/image/832/832/xif0q/kids-shoe/r/g/t/-original-imaghugx8hpatrkg.jpeg?q=70",
    category: "Sports shoes",
    price: "2740",
    originalPrice: "3500",
    rating: "3.8",
    gender: "Kids",
    inStock: true,
    reviews: "7.1k",
    delivery: "in 2 days",
  },
  {
    _id: uuid(),
    name: "Lace Football Shoes For Boys & Girls  (Black)",
    brand: "PUMA",
    image:
      "https://rukminim1.flixcart.com/image/832/832/xif0q/kids-shoe/s/h/z/2-106562-puma-original-imaggar6ygbcqunh.jpeg?q=70",
    category: "Sports shoes",
    price: "2000",
    originalPrice: "3000",
    rating: "2.5",
    gender: "Kids",
    inStock: true,
    reviews: "969",
    delivery: "in 6 days",
  },

  {
    _id: uuid(),
    name: "Rock Casual High Tops For Men  (Black)",
    brand: "PUMA",
    image:
      "https://rukminim1.flixcart.com/image/832/832/xif0q/shoe/6/8/8/10-na-p388708-puma-black-castlerock-team-gold-original-imagz78n9zqbmufb.jpeg?q=70",
    category: "Boots",
    price: "4500",
    originalPrice: "6000",
    rating: "2.5",
    gender: "Men",
    inStock: true,
    reviews: "4.3k",
    delivery: "in 7 days",
  },

  {
    _id: uuid(),
    name: "Boots For Men  (Brown)",
    brand: "BATA",
    image:
      "https://rukminim1.flixcart.com/image/832/832/kwpam4w0/shoe/p/6/n/8-8044333-8-bata-brown-original-imag9bheksgzhxek.jpeg?q=70",
    category: "Boots",
    price: "2680",
    originalPrice: "3500",
    rating: "3.6",
    gender: "Men",
    inStock: true,
    reviews: "8.1k",
    delivery: "in 6 days",
  },
  {
    _id: uuid(),
    name: "Boots For Men  (Black)",
    brand: "NIKE",
    image:
      "https://rukminim1.flixcart.com/image/612/612/xif0q/shoe/v/5/b/-original-imaghvb92zkacjhq.jpeg?q=70",
    category: "Boots",
    price: "5000",
    originalPrice: "7500",
    rating: "4.2",
    gender: "Men",
    inStock: false,
    reviews: "7.2k",
    delivery: "in 1 days",
  },
  {
    _id: uuid(),
    name: "Boots For Men  (Khaki)",
    brand: "ADIDAS",
    image:
      "https://rukminim1.flixcart.com/image/832/832/xif0q/shoe/9/x/5/hero-boot-321-9-aadi-tan-original-imaev4r6yjwqzy5s-bb.jpeg?q=70",
    category: "Boots",
    price: "3000",
    originalPrice: "4500",
    rating: "2.2",
    gender: "Men",
    inStock: true,
    reviews: "63",
    delivery: "in 2 days",
  },

  {
    _id: uuid(),
    name: "Boots For Women  (Black)",
    brand: "BATA",
    image:
      "https://rukminim1.flixcart.com/image/832/832/xif0q/shoe/7/d/c/3-6016042-3-bata-black-original-imagguehpsbtgvrr.jpeg?q=70",
    category: "Boots",
    price: "3999",
    originalPrice: "4500",
    rating: "4.3",
    gender: "Women",
    inStock: true,
    reviews: "2.4k",
    delivery: "in 6 days",
  },
  {
    _id: uuid(),
    name: "Stylish casual partywear women heeled boots Boots For Women  (Brown)",
    brand: "ADIDAS",
    image:
      "https://rukminim1.flixcart.com/image/832/832/xif0q/shoe/i/d/p/-original-imagg3m8qtqrkga8.jpeg?q=70",
    category: "Boots",
    price: "2500",
    originalPrice: "3459",
    rating: "2.8",
    gender: "Women",
    inStock: true,
    reviews: "96",
    delivery: "in 2 days",
  },
  {
    _id: uuid(),
    name: "Ankle Boots for Women's Boots For Women  (Black)",
    brand: "NIKE",
    image:
      "https://rukminim1.flixcart.com/image/832/832/xif0q/shoe/o/s/a/5-1101-black-myshtezia-black-original-imaghmdgmexcz92j.jpeg?q=70",
    category: "Boots",
    price: "1500",
    originalPrice: "2999",
    rating: "1.5",
    gender: "Women",
    inStock: false,
    reviews: "1.5k",
    delivery: "in 3 days",
  },
  {
    _id: uuid(),
    name: "Boots For Women  (Black)",
    brand: "PUMA",
    image:
      "https://rukminim1.flixcart.com/image/832/832/xif0q/kids-shoe/y/i/b/4-k-bt-608-stylestry-original-imagj8bpuqhfg7zs.jpeg?q=70",
    category: "Boots",
    price: "2300",
    originalPrice: "3200",
    rating: "3.2",
    gender: "Women",
    inStock: false,
    reviews: "2k",
    delivery: "in 2 days",
  },

  {
    _id: uuid(),
    name: "Lace Casual Boots For Boys  (Brown)",
    brand: "BATA",
    image:
      "https://rukminim1.flixcart.com/image/832/832/xif0q/kids-shoe/y/i/b/4-k-bt-608-stylestry-original-imagj8bpuqhfg7zs.jpeg?q=70",
    category: "Boots",
    price: "1300",
    originalPrice: "2000",
    rating: "1.5",
    gender: "kids",
    inStock: true,
    reviews: "5.6k",
    delivery: "in 1 days",
  },
  {
    _id: uuid(),
    name: "Lace Casual Boots For Boys  (Brown)",
    brand: "ADIDAS",
    image:
      "https://rukminim1.flixcart.com/image/832/832/xif0q/kids-shoe/g/5/x/8c-na-art-1003-chivalu-original-imagzk5k99quyfxf.jpeg?q=70",
    category: "Boots",
    price: "1500",
    originalPrice: "2500",
    rating: "2.9",
    gender: "kids",
    inStock: true,
    reviews: "5.1k",
    delivery: "in 2 days",
  },
  {
    _id: uuid(),
    name: "Lace Casual Boots For Boys  (Black)",
    brand: "NIKE",
    image:
      "https://rukminim1.flixcart.com/image/612/612/kzzw5u80/kids-shoe/2/1/n/13-110-siya-original-imagbvqw4r5qxndr.jpeg?q=70",
    category: "Boots",
    price: "2210",
    originalPrice: "3200",
    rating: "3.5",
    gender: "kids",
    inStock: true,
    reviews: "66",
    delivery: "in 4 days",
  },
];
